import { Action } from 'redux';
import { Metadata, Schema } from '../../types/Metadata';

export interface AdministrationState {
  reqNum?: number;
  data?: Partial<Metadata>;
  original?: Partial<Metadata>;
  schema?: Schema;
}

const UPDATE_ADMINISTRATION_STATE = 'UPDATE_ADMINISTRATION_STATE';

export const updateAdministrationState = (
  newState: Partial<AdministrationState>
) => ({
  type: UPDATE_ADMINISTRATION_STATE,
  ...newState
});

type FormAction = Action & Partial<AdministrationState>;

const reducer = (
  state: AdministrationState = {},
  action: FormAction
): AdministrationState => {
  const { type, ...newState } = action;
  switch (type) {
    case UPDATE_ADMINISTRATION_STATE:
      if (newState.reqNum && state.data) {
        const { reqNum, original } = newState;
        if (original && state.reqNum <= reqNum) {
          const data = state.data;
          const { metadata, props } = original;
          if (metadata) data.metadata = metadata;
          if (props?.modifiedBy) data.props.modifiedBy = props.modifiedBy;
        }
      } else if (!newState.schema && !newState.data) return {};
      return { ...state, ...newState };
    default:
      return state;
  }
};

export default reducer;
